import axios from '@/libs/api.request.js';

const memberSign = {

    // 获取当前可用的签到规则
    getMemberSignRules: () => {
        return axios.get({
            url: '/wap/MemberSign/Rules'
        })
    },
    // 获取签到记录
    getMemberSignRecord: () => {
        return axios.get({
            url: '/wap/MemberSign/record'
        })
    },
    // 获取历史签到记录
    getMemberSignRecordList: (data) => {
        return axios.get({
            url: '/wap/MemberSign/SignRecordList?' + axios.parseParams(data),
        })
    },
    // 签到
    memberSign() {
        return axios.post({
            url: '/wap/MemberSign'
        });
    }
};

export default memberSign;


// WEBPACK FOOTER //
// ./src/api/api-memberSign.js